if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
  super();

  this.form = this.querySelector("form");

  this.form.querySelector("[name=id]")?.removeAttribute("disabled");

  this.form.addEventListener(
    "submit",
    this.onSubmitHandler.bind(this)
  );


  this.addEventListener("change", () => {

    setTimeout(()=>{

      const variantComponent = document.querySelector(
        'variant-radios,variant-selects'
      );


      const variantId = variantComponent?.currentVariant?.id;


      const input = this.form.querySelector(
        'input[name="id"]'
      );


      if(variantId && input){

        input.value = variantId;


        const buyNowInput =
        this.querySelector('.buy-now-variant');


        if(buyNowInput){
          buyNowInput.value = variantId;
        }


        console.log(
          "更新variant:",
          variantId
        );

      }

    },150);

  });


  this.cart = document.querySelector("cart-drawer");

  this.submitButton = this.querySelector(
    '[type="submit"]'
  );

  this.hideErrors =
  this.dataset.hideErrors === 'true';
}

      onSubmitHandler(evt) {
        evt.preventDefault();

        //【核心修复：提交瞬间读取选中尺码，强制覆盖】
const variantInput = this.form.querySelector('input[name="id"]');
let selectedVariantId = variantInput?.value || null;

        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.remove("hidden");

        const formData = new FormData(this.form);
        //强制重写变体ID，根治缓存旧XS尺码
        if(selectedVariantId) formData.set("id",selectedVariantId);
        const variantId = formData.get("id");
        const quantity = parseInt(formData.get("quantity") || 1);

        fetch(`${window.routes?.cartUrl || "/cart"}.js`, {
          method: 'GET'
        })
        .then(res=>res.json())
        .then(cart=>{
          const existNum = cart.items
            .filter(item=>String(item.variant_id) === String(variantId))
            .reduce((sum,item)=> sum + item.quantity,0);
          const totalQty = existNum + quantity;

          if(existNum > 0){
            const updateData = {updates:{}};
            updateData.updates[variantId] = totalQty;
            return fetch(window.routes.cartUpdateUrl,{
              method:"POST",
              headers:{
 "Content-Type":"application/json"
},
              body:JSON.stringify(updateData)
            }).then(r=>r.json()).then(res=>{
              return {isUpdate:true,res}
            })
          }else{
            return fetch(window.routes.cartAddUrl,{
              method:"POST",
              headers:{
 "Content-Type":"application/json"
},
              body:JSON.stringify({
                id:variantId,
                quantity:quantity
              })
            }).then(r=>r.json()).then(res=>{
              return {isUpdate:false,res}
            })
          }
        })
        .then(result=>{
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");

          if(result.res?.status){
            this.handleErrorMessage(result.res.message);
            return;
          }
          this.cart?.renderContents();
          publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form'});
        })
        .catch(err=>{
          this.submitButton.classList.remove("loading");
          this.submitButton.removeAttribute("aria-disabled");
          console.error(err);
        })
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }
    }
  );
}
